var map = {
	"./DaxExch-logo.png": 1422,
	"./Fairplay_New_Logo.png": 1423,
	"./Fairplay_New_Logo_l.png": 1424,
	"./MatrixExch-logo.png": 1425,
	"./MatrixExch-logo_w.png": 1426,
	"./PlayExch-logo.png": 1427,
	"./PlayExch-logo_w.png": 1428,
	"./ZeExch-logo.png": 1429,
	"./ZodExch-logo.png": 1430,
	"./ZodExch-logo1.png": 1431,
	"./fairnews-logo.png": 1432,
	"./fairplay-website-logo.png": 164,
	"./menu.png": 606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1421;